import React, { Component } from "react";

import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import { injectIntl } from "react-intl";
import Visibility from "../../../../component/common/VisibleContainer";
import { sanitizeValue } from "../../../../utils/ObjectUtils";
import SurveyUtils from "../../../../utils/SurveyUtils";
import { LIBRARY_EDITOR } from "./../../../../common/constant";

/**
 * Component which represents rows of table for questions from library
 */
class QuestionLibraryOverviewRows extends Component {

  render() {
    const { intl, question, showSettingsModalQuestionToLibrary, sortTableBy, locale } = this.props;
    let typeId = "question.library.language." + question.question.type;
    return (
      <tr>
        <td className={SurveyUtils.addClassForTableColumns("name", sortTableBy)}>{sanitizeValue(question.name)}</td>
        <td className={SurveyUtils.addClassForTableColumns("questionId", sortTableBy)}>{question.questionId}</td>
        <td className={SurveyUtils.addClassForTableColumns("question", sortTableBy)}>
          {intl.formatMessage({ id: typeId })}
        </td>
        <td className={SurveyUtils.addClassForTableColumns("language", sortTableBy)}>
          {question.language ? question.language.name : "-"}
        </td>
        <td className={SurveyUtils.addClassForTableColumns("actionField", sortTableBy)}>
          {question.actionField
            ? question.actionField.name[locale]
            : intl.formatMessage({ id: "question.library.all" })}
        </td>
        <td className={SurveyUtils.addClassForTableColumns("result", sortTableBy)}>
          {question.result ? question.result.name[locale] : intl.formatMessage({ id: "question.library.all" })}
        </td>
        <Visibility roles={[LIBRARY_EDITOR]} as="td" className="actions">
          <Button
            size="sm"
            title={intl.formatMessage({ id: "app.common.action.edit" })}
            onClick={() => showSettingsModalQuestionToLibrary(question)}
            variant="link"
          >
            <FontAwesomeIcon icon={faEdit} />
          </Button>
        </Visibility>
      </tr>
    );
  }
}

QuestionLibraryOverviewRows.propTypes = {
  question: PropTypes.object,
  showSettingsModalQuestionToLibrary: PropTypes.func,
  sortTableBy: PropTypes.string,
  locale: PropTypes.string.isRequired
};

export default injectIntl(QuestionLibraryOverviewRows);
